export enum eLegalEntityType {
    "Persona física" = 1,
    "Persona jurídica" = 2
}